const stmp = {
    show(eventName,userId,params){
        let datas={
            eventId: eventName,
            liveType: "02",
            appType:"03",
            channel:"02",
            userId:userId,
            eventType:"02"
          }
          datas.attstr = params;
            var items = [];
            items.push(datas);
            var res = {
                items: items
            };
            return res;
    },
    knock(eventName,userId,params){
        let datas={
            eventId: eventName,
            liveType: "02",
            appType:"03",
            channel:"02",
            userId:userId,
            eventType:"01"
          }
        datas.attstr = params;
        var items = [];
        items.push(datas);
        var res = {
            items: items
        };
        return res
    }
}
export default stmp;


// WEBPACK FOOTER //
// ./src/cmtapp/components/util/stmp.js